import styled from "@emotion/styled";

export const FieldMappingContainer = styled.div`
  display: flex;
  align-items: center;
`;
